<template>
  <transition name="order-lesson-trigger">
    <button
      v-if="shouldShowTrigger"
      type="button"
      class="order-lesson__trigger"
      :class="triggerClasses"
      @click.prevent="showCallForm"
    >
      <template v-if="showButton">
        <span class="order-lesson__trigger-kicker">Prochaine session</span>
        <strong>s'inscrire à la prochaine session</strong>
        <small>{{ lesson }}</small>
      </template>
      <template v-else>
        <span class="order-lesson__trigger-label">s'inscrire</span>
      </template>
    </button>
  </transition>

  <transition name="order-lesson-modal">
    <div
      v-if="OrderLesson"
      class="order-lesson__overlay"
      @click.self="closeOrder"
    >
      <section class="order-lesson__dialog">
        <button
          type="button"
          class="order-lesson__close"
          aria-label="Fermer la fenêtre d'inscription"
          @click="closeOrder"
        >
          <span aria-hidden="true">×</span>
        </button>

        <div class="order-lesson__hero">
          <p class="order-lesson__eyebrow">Pré-inscription</p>
          <h4>{{ lesson }}</h4>
          <p>
            Notre équipe vous recontact dans les plus brefs délais pour répondre
            à vos questions et établir les prochaines étapes de votre
            inscription.
          </p>
          <p>
            L'institut taxi se charge de toute les démarches administratives,
            vous transmettez les documents nécéssaire à votre inscription par
            mail ou venez à notre rencontre à l'institut pour déposé les pièces
            à fournirs.
          </p>
        </div>

        <div class="order-lesson__form-shell">
          <form
            ref="formData"
            class="order-lesson__form"
            @submit.prevent="sendEmail"
          >
            <input
              type="hidden"
              name="reason"
              value="Inscription à une formation"
              required
            />
            <input type="hidden" name="order" :value="lesson" required />

            <div class="order-lesson__fields">
              <label class="order-lesson__field">
                <span>Votre nom</span>
                <input
                  type="text"
                  placeholder="Votre Nom"
                  name="name"
                  maxlength="30"
                  required
                />
              </label>

              <label class="order-lesson__field">
                <span>Votre téléphone</span>
                <input
                  type="tel"
                  placeholder="Votre Téléphone"
                  name="phone"
                  required
                  pattern="^(\\+?\\d{1,3}[- ]?)?\\d{10}$"
                />
              </label>
            </div>

            <div class="order-lesson__actions">
              <button name="button" type="submit" class="order-lesson__submit">
                Envoyer
              </button>
            </div>
          </form>
        </div>

        <span v-if="this.modalConfirm">
          <ConfirmModal
            @closeModalConfirm="closeModalConfirm"
            title="Merci de votre intérêt"
            message="Vous allez être recontactés dans les plus brefs délais"
            btnExit="À bientôt"
          />
        </span>
      </section>
    </div>
  </transition>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import ConfirmModal from "@/components/modals/ConfirmModal.vue";

export default {
  components: { ConfirmModal },
  props: {
    lesson: String,
    inlineInParent: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      OrderLesson: false,
      modalConfirm: false,
      showButton: false,
      scrollHeight: 300,
    };
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener("scroll", this.handleScroll);
    });
  },
  beforeUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  computed: {
    ...mapGetters({
      SendingEmail: "StateSendingEmail",
      EmailSent: "StateEmailSent",
      EmailError: "StateEmailError",
    }),
    shouldShowTrigger() {
      return !this.OrderLesson && (this.showButton || this.inlineInParent);
    },
    triggerClasses() {
      return this.showButton
        ? "order-lesson__trigger--fixed"
        : "order-lesson__trigger--inline";
    },
  },
  methods: {
    ...mapActions(["SendCallMeMail"]),
    sendEmail() {
      this.SendCallMeMail(this.$refs.formData);
      this.modalConfirm = true;
      this.$refs.formData.reset();
    },
    closeModalConfirm() {
      this.modalConfirm = false;
      this.OrderLesson = false;
    },
    showCallForm() {
      this.OrderLesson = true;
      this.showButton = false;
    },
    handleScroll() {
      if (window.pageYOffset > this.scrollHeight && this.OrderLesson != true) {
        this.showButton = true;
      } else {
        this.showButton = false;
      }
    },
    closeOrder() {
      this.OrderLesson = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.order-lesson__trigger {
  z-index: 120;
  width: min(calc(100vw - 36px), 360px);
  padding: 14px 18px 16px;
  border: 0;
  border-radius: 24px;
  background: $color-primary;
  color: $color-text-light;
  text-align: left;
  display: inline-flex;
  flex-direction: column;
  align-items: flex-start;
  box-shadow: 0 20px 34px rgba(0, 42, 84, 0.24),
    0 0 0 1px rgba(254, 185, 20, 0.14), inset 0 1px 0 rgba(255, 255, 255, 0.06);
  transition: transform 0.2s ease, box-shadow 0.2s ease;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 24px 38px rgba(0, 42, 84, 0.28),
      0 0 0 1px rgba(254, 185, 20, 0.18),
      inset 0 1px 0 rgba(255, 255, 255, 0.08);
  }

  &:focus-visible {
    outline: 3px solid rgba(254, 185, 20, 0.76);
    outline-offset: 4px;
  }

  strong,
  small,
  span {
    display: block;
  }

  strong {
    margin-top: 6px;
    font-family: "quantum";
    font-size: 0.98rem;
    font-weight: normal;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    line-height: 1.08;
  }

  small {
    margin-top: 8px;
    font-family: "adam";
    font-size: 0.58rem;
    letter-spacing: 0.16em;
    text-transform: uppercase;
    color: rgba(245, 236, 236, 0.72);
  }
}

.order-lesson__trigger--fixed {
  position: fixed;
  top: 96px;
  right: 18px;
}

.order-lesson__trigger--inline {
  position: relative;
  width: fit-content;
  align-self: flex-end;
  padding: 10px;
  border-radius: 999px;
  background: $color-secondary;
  color: $color-primary;
  box-shadow: 0 12px 22px rgba(254, 185, 20, 0.24);

  &:hover {
    box-shadow: 0 14px 24px rgba(254, 185, 20, 0.28);
  }
}

.order-lesson__trigger--inline .order-lesson__trigger-label {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-family: "quantum";
  font-size: 0.62rem;
  letter-spacing: 0.04em;
  line-height: 1;
  text-transform: uppercase;
}

.order-lesson__trigger-kicker {
  width: fit-content;
  min-height: 20px;
  padding: 7px;
  border-radius: 999px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: $color-secondary;
  color: $color-primary;
  font-family: "adam";
  font-size: 0.5rem;
  letter-spacing: 0.08em;
  line-height: 1;
  text-transform: uppercase;
  box-shadow: 0 8px 14px rgba(254, 185, 20, 0.18);
  margin-bottom: 10px;
}

.order-lesson__trigger--fixed .order-lesson__trigger-kicker {
  background: #000000;
  color: $color-secondary;
  box-shadow: 0 10px 18px rgba(0, 0, 0, 0.22);
}

.order-lesson__overlay {
  position: fixed;
  inset: 0;
  z-index: 10000;
  box-sizing: border-box;
  display: grid;
  place-items: center;
  padding: 18px;
  overflow-y: auto;
  overscroll-behavior: contain;
  -webkit-overflow-scrolling: touch;
  background: rgba(4, 10, 18, 0.7);
  backdrop-filter: blur(10px);
}

.order-lesson__dialog {
  position: relative;
  width: min(100%, 980px);
  max-height: calc(100vh - 36px);
  max-height: calc(100dvh - 36px);
  border-radius: 32px;
  overflow-x: hidden;
  overflow-y: auto;
  overscroll-behavior: contain;
  -webkit-overflow-scrolling: touch;
  display: grid;
  background: #ffffff;
  box-shadow: 0 26px 54px rgba(0, 0, 0, 0.28);

  @media screen and (min-width: 992px) {
    grid-template-columns: minmax(320px, 0.96fr) minmax(0, 1.04fr);
  }
}

.order-lesson__close {
  position: absolute;
  top: 16px;
  right: 16px;
  z-index: 2;
  width: 42px;
  height: 42px;
  border: 0;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.1);
  color: $color-text-light;
  font-size: 1.6rem;
  line-height: 1;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.16);
}

.order-lesson__hero {
  padding: clamp(28px, 4vw, 40px);
  background: $color-primary;
  color: $color-text-light;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 16px;

  h4 {
    margin: 0;
    font-family: "quantum";
    font-size: clamp(1.7rem, 2vw + 1rem, 2.4rem);
    font-weight: normal;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    line-height: 1.04;
  }

  p {
    margin: 0;
    color: rgba(245, 236, 236, 0.9);
    line-height: 1.72;
  }
}

.order-lesson__eyebrow {
  width: fit-content;
  min-height: 34px;
  padding: 0 14px;
  border-radius: 999px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: $color-secondary;
  color: $color-primary;
  font-family: "adam";
  font-size: 0.68rem;
  letter-spacing: 0.18em;
  text-transform: uppercase;
}

.order-lesson__form-shell {
  padding: clamp(24px, 4vw, 38px);
  background: #ffffff;
}

.order-lesson__form {
  display: flex;
  flex-direction: column;
  gap: 22px;
}

.order-lesson__fields {
  display: grid;
  gap: 16px;
}

.order-lesson__field {
  display: grid;
  gap: 8px;

  span {
    color: $color-primary;
    font-family: "adam";
    font-size: 0.66rem;
    letter-spacing: 0.16em;
    text-transform: uppercase;
  }

  input {
    width: 100%;
    min-height: 56px;
    border: 1px solid rgba(0, 42, 84, 0.12);
    border-radius: 18px;
    padding: 0 16px;
    background: rgba(0, 42, 84, 0.04);
    color: $color-text;
    transition: border-color 0.2s ease, box-shadow 0.2s ease,
      background-color 0.2s ease;

    &:focus {
      border-color: rgba(0, 42, 84, 0.22);
      background: #ffffff;
      box-shadow: 0 0 0 4px rgba(0, 42, 84, 0.08);
      outline: none;
    }

    &::placeholder {
      color: rgba(0, 42, 84, 0.46);
    }
  }
}

.order-lesson__actions {
  display: flex;
  justify-content: flex-start;
}

.order-lesson__submit {
  min-height: 52px;
  padding: 0 26px;
  border: 0;
  border-radius: 999px;
  background: $color-secondary;
  color: $color-primary;
  font-family: "quantum";
  font-size: 0.92rem;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  box-shadow: 0 16px 24px rgba(254, 185, 20, 0.18);
  transition: transform 0.2s ease, box-shadow 0.2s ease;

  &:hover {
    transform: translateY(-1px);
    box-shadow: 0 20px 28px rgba(254, 185, 20, 0.22);
  }

  &:active {
    transform: translateY(1px);
  }
}

.order-lesson-trigger-enter-active,
.order-lesson-trigger-leave-active,
.order-lesson-modal-enter-active,
.order-lesson-modal-leave-active {
  transition: opacity 0.22s ease, transform 0.22s ease;
}

.order-lesson-trigger-enter-from,
.order-lesson-trigger-leave-to {
  opacity: 0;
  transform: translateY(10px);
}

.order-lesson-modal-enter-from,
.order-lesson-modal-leave-to {
  opacity: 0;

  .order-lesson__dialog {
    transform: translateY(14px) scale(0.98);
  }
}

@media screen and (min-width: 992px) {
  .order-lesson__trigger {
    width: 360px;
  }

  .order-lesson__trigger--fixed {
    top: 118px;
    right: 28px;
  }

  .order-lesson__trigger--inline {
    width: fit-content;
  }

  .order-lesson__fields {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media screen and (max-width: 767px) {
  .order-lesson__trigger {
    width: min(calc(100vw - 28px), 300px);
    border-radius: 22px;
  }

  .order-lesson__trigger--fixed {
    top: 84px;
    right: 14px;
  }

  .order-lesson__trigger--inline {
    width: fit-content;
    max-width: none;
    margin-left: 0;
    align-self: flex-start;
  }

  .order-lesson__overlay {
    height: 100vh;
    height: 100dvh;
    padding: max(14px, env(safe-area-inset-top)) 14px
      max(14px, env(safe-area-inset-bottom));
    place-items: start center;
  }

  .order-lesson__dialog {
    max-height: calc(100vh - 28px);
    max-height: calc(100dvh - 28px);
    border-radius: 26px;
  }

  .order-lesson__close {
    top: 12px;
    right: 12px;
  }

  .order-lesson__hero,
  .order-lesson__form-shell {
    padding: 22px 18px;
  }

  .order-lesson__actions {
    justify-content: stretch;
  }

  .order-lesson__submit {
    width: 100%;
  }
}
</style>
